import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import mapValues from 'lodash/mapValues';

/**
 * Invokes a function against every object or item in an array
 * @param {object | object[]} obj
 * @param {(...args) => any} mapper
 */
export const deep = (obj, mapper) => {
    if (isArray(obj)) {
        return obj.map((value) => deep(value, mapper));
    }

    if (isPlainObject(obj)) {
        return mapValues(mapper(obj), (value) => deep(value, mapper));
    }

    return obj;
};
